import Mutations from '../../odata/mutations';

export default { ...new Mutations('payrollSheetItem'), ...new Mutations('payrollSheetItems') };
